const READ_MORE_CONTAINER = '[data-read-more]';
const READ_MORE_TOGGLE = '[data-read-more-toggle]';

// Classes
const CLASS_CONTENT_OPEN = 'is-open';

document.addEventListener('click', function(e) {
    // Check if the clicked element matches the toggle selector
    if (e.target.matches(READ_MORE_TOGGLE)) {
        e.preventDefault();
        e.stopPropagation();

        const toggleBtn = e.target;
        const toggleContainer = toggleBtn.closest(READ_MORE_CONTAINER);

        if (!toggleContainer) return;

        const isOpen = toggleContainer.classList.contains(CLASS_CONTENT_OPEN);

        if (isOpen) {
            toggleContainer.classList.remove(CLASS_CONTENT_OPEN);
            toggleBtn.textContent = Language.strings['general.read_more_toggle.read_more'];
        } else {
            toggleContainer.classList.add(CLASS_CONTENT_OPEN);
            toggleBtn.textContent = Language.strings['general.read_more_toggle.read_less'];
        }
    }
});
